import Firebase from '../../lib/Firebase';
import Firestore from '../../lib/Firestore';


export default {
  saveCityInformation(hotelId, name, configs) {
    const cityObj = {
      name,
      configs
    };

    return Firebase.firestore()
      .collection('hotels')
      .doc()
      .update(cityObj);
  },

  tax(){
    return Firebase.firestore().collection('global-configs')
    .get()
    .then((docs) => {
      return Firestore.getCollectionData(docs);
    });
  },
  hotelTypes(){
    return Firebase.firestore().collection('hotelTypes')
    .get()
    .then((docs) => {
      return Firestore.getCollectionData(docs);
    });
  },
  destinations(){
    return Firebase.firestore().collection('destinations')
    .get()
    .then((docs) => {
      return Firestore.getCollectionData(docs);
    });
  },
  deletDestination(destination) {
    console.log(this.destination);
    return Firebase.firestore()
      .collection('destinations')
      .doc(destination)
      .delete();
      
  },
  deleteHoteltype(hotelType) {
    console.log(this.hotelType);
    return Firebase.firestore()
      .collection('hotelTypes')
      .doc(hotelType)
      .delete();
      
  },
 
  manageDestination(destinationId, name) {
    const destinationObj = {
      name
    };
    const promise = destinationId
    ? Firebase.firestore()
      .collection('destinations')
      .doc(destinationId)
      .update(destinationObj)
    : Firebase.firestore()
      .collection('destinations')
      .add(destinationObj);
      
    return promise;
  },
  manageHotelTypes(destinationId, typeName) {
    const destinationObj = {
      typeName
    };
    const promise = destinationId
    ? Firebase.firestore()
      .collection('hotelTypes')
      .doc(destinationId)
      .update(destinationObj)
    : Firebase.firestore()
      .collection('hotelTypes')
      .add(destinationObj);
      
    return promise;
  },
  saveTax(gstNo, sgst, cgst) {
    const taxObj = {
      gstNo,
      sgst,
      cgst
    };
   
    return Firebase.firestore()
      .collection('global-configs')
      .doc('all-configs')
      .update(taxObj)
 
  }
};



// WEBPACK FOOTER //
// ./src/pages/settings/service.js